module.exports = __webpack_public_path__ + "static/media/glass-martini-alt.1f85d5d2.svg";